<template>
	<div class="yulan" v-if="url" @click.self="Guanbi">			
		<img :src="url" class="img"></img>
		<i class="elDialogClose el-icon el-icon-close" @click="Guanbi"></i>
	</div>
</template>

<script>
	export default {
		data() {
			return {url:''}
		},
		methods: {
			Yulan(e){
				this.url=e
			},
			Guanbi(){
				this.url=''
			}
		}
	}
</script>

<style scoped="scoped">
	.yulan{height: 100vh;width: 100%;background-color: rgba(0,0,0,0.7);position: fixed;z-index: 9999;left: 0;top: 0;display: flex;justify-content: center;align-items: center;}
	.yulan .img{background-color: #FFFFFF;border-radius: 5px;max-height: 80%;}
	.yulan .elDialogClose{right: 20px;top:20px;color: #FFFFFF;position: absolute;font-size:30px;cursor: pointer;}
</style>
